var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpen({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7997 14.3L21.3997 19.3C21.2497 20.83 21.1297 22 18.4197 22H5.83965C3.12965 22 3.00965 20.83 2.85965 19.3L2.45965 14.3C2.37965 13.47 2.63965 12.7 3.10965 12.11C3.11965 12.1 3.11965 12.1 3.12965 12.09C3.67965 11.42 4.50965 11 5.43965 11H18.8197C19.7497 11 20.5696 11.42 21.1096 12.07C21.1196 12.08 21.1297 12.09 21.1297 12.1C21.6197 12.69 21.8897 13.46 21.7997 14.3Z",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.62891 11.4303V6.28027C3.62891 2.88027 4.47891 2.03027 7.87891 2.03027H9.14891C10.4189 2.03027 10.7089 2.41027 11.1889 3.05027L12.4589 4.75027C12.7789 5.17027 12.9689 5.43027 13.8189 5.43027H16.3689C19.7689 5.43027 20.6189 6.28027 20.6189 9.68027V11.4703",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55859 17H14.6986",
    stroke: "#5C6E7D",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpen);
export default __webpack_public_path__ + "static/media/open.b20f13897febec1caa9a0a3eaf584c37.svg";
export { ForwardRef as ReactComponent };